import { Dialog, DialogContent } from '../../../../common/components/ui/dialog';
import { abortUserInputForCart } from '../../actions/cartActions';
import { CartDialogDeliveryDateExpired } from './CartDialogDeliveryDateExpired.tsx';
import { CartDialogChooseDeliveryDate } from './CartDialogChooseDeliveryDate';
import { CartDialogCreation } from './CartDialogCreation';
import type { ReactNode } from 'react';
import { getLogger } from '../../../../logging/logger';
import { CartDialogChoosePositionAvailabilityOptions } from './CartDialogChoosePositionAvailabilityOption';
import { type CartUserPromptDialogDescriptor } from '../../state-hooks/useCartUserPromptNotification';

const clientLog = getLogger('cart-progress-dialog');

type CartUserPromptDialogProp = {
  userPromptDialogContentDescriptor: CartUserPromptDialogDescriptor;
};

export function CartUserPromptDialog({ userPromptDialogContentDescriptor }: Readonly<CartUserPromptDialogProp>) {
  if (!userPromptDialogContentDescriptor) {
    return null;
  }

  let dialogContent: ReactNode;
  let showCloseButton = false;
  let dialogCloseHandler: ((open: boolean) => void) | undefined = undefined;

  switch (userPromptDialogContentDescriptor) {
    case 'POSITION_AVAILABILITY_OPTIONS':
      dialogContent = <CartDialogChoosePositionAvailabilityOptions />;
      break;
    case 'DELIVERY_DATE_CREATION':
      dialogContent = <CartDialogCreation />;
      break;
    case 'DELIVERY_DATE_EXPIRED':
      dialogContent = <CartDialogDeliveryDateExpired />;
      dialogCloseHandler = abortUserInputForCart;
      break;
    case 'DELIVERY_DATE_CHANGE':
      dialogContent = <CartDialogChooseDeliveryDate />;
      showCloseButton = true;
      dialogCloseHandler = abortUserInputForCart;
      break;
    case 'DELIVERY_DATE_CHANGE_PROCESSING': // jonas, 2026-05-01: Dieser Case sollte wohl auf den CartBusyDiealog verschoben werden ...
      dialogContent = <CartDialogChooseDeliveryDate />;
      dialogCloseHandler = abortUserInputForCart;
      break;
    default: {
      clientLog.error('CartUserPromptDialog: unhandled dialogContentDescriptor:', userPromptDialogContentDescriptor);
      return null;
    }
  }

  function handleClose(open: boolean) {
    if (!open && dialogCloseHandler) {
      dialogCloseHandler(open);
    }
  }

  return (
    <Dialog open={true} onOpenChange={handleClose}>
      <DialogContent
        showFullscreenOnMobile
        className="max-w-5xl desktop:max-w-2xl w-full"
        showClose={showCloseButton}
        aria-describedby={undefined} // unterdrückt Warnung in Browser Dev Console
        data-testid={'cart-dialog'}
      >
        {dialogContent}
      </DialogContent>
    </Dialog>
  );
}
